import React, { useContext, useRef } from 'react';
import { AppText, Button } from 'src/style';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import ReactToPrint from 'react-to-print';
import Html2Pdf from 'html2pdf.js'
import { ReceiptView } from './receiptView';
import { Design } from 'src/model';
import DownloadIcon from 'src/assets/svg/receipt-download-icon-d2'

export const Reciept: React.FC<any> = ({txData}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)
    const componentRef = useRef(null);


    return (
        <>
            <ReactToPrint
                trigger={() => 
                    institutionData.design != Design.DESIGN_2 ? 
                        <AppText color="#3A3A3A" cursor="pointer" hoverColor="#0D968F">Download Receipt</AppText>
                        : 
                        <Button 
                            width='100' sizeUnit="%" height='4.4'
                            bgColor='#E7F6F5' color='#0D968F'
                            titleSize='1.4'
                        >
                            <DownloadIcon style={{marginRight: '1rem'}} className="icon-component" />
                            Download Receipt
                        </Button>
                }
                content={() => componentRef.current}
                removeAfterPrint={true}
                // Remove the print function below to show preview
                // print={ async (printIframe) => {
                //     const document = printIframe.contentDocument;
                //     if (document) {
                //       const html = document.getElementsByTagName("html")[0];
                //       const exporter = new Html2Pdf(html, {filename: `${institutionData?.name} Receipt ${txData?.transactionDate} ${txData?.transactionReference}`});
                //       await exporter.getPdf(true);
                //     }
                //   }
                // }
            />
            <div style={{display: 'none'}}>
                <ReceiptView ref={componentRef} data={txData} />
            </div>
        </>
    );
};